import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import AUTO_ENROLLMENT_QUERY from './GetAutoEnrollment.gql';

const parseResult = result => {
  const initialState = {
    accepted: false,
  };

  const autoEnrollment = get(result, 'core.getAutoEnrollmentStatus');

  return {
    ...initialState,
    ...autoEnrollment,
  };
};

export const useAutoEnrollmentQuery = options => {
  const [queryResult, queryAction] = useQuery(AUTO_ENROLLMENT_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
